import React, { } from "react";
import { Tooltip, Box } from '@mui/material';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { uploadSelector } from "../store/slices/upload";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { getFolderName, convertArrayToDictionary } from "../common/utils";


const getData = (files, usersDic, groupId) => {
  let modifiedFiles = _.map(files, file => {
    return { ...file, folderName: getFolderName(file?.parent?.prefix) }
  })
  let groupedRecords = _.groupBy(modifiedFiles, 'folderName')
  let fileData = _.map(groupedRecords, (file, groupedBy) => {
    let user = usersDic[groupedBy]
    return { name: groupedBy, path: file.name, size: _.sumBy(file, 'properties.length'), lastModified: null, modifiedBy: user?.Email, ext: 'folder' };
  });
  return fileData;
};
const FilterSideBar = ({ groupId, setGroupId }) => {
  const dispatch = useDispatch();
  const { users, files } = useSelector(uploadSelector);
  const usersDic = React.useMemo(() => convertArrayToDictionary(users, 'CustomUserId'), [users]);
  const finalData = React.useMemo(() => getData(files, usersDic), [files, usersDic]);
  return (
    <>
      <div className="viewbar sidebar" style={{ borderBottom: "none" }}>
        <div className="view-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: "1.5rem", display: "block" }}>
            {"Files"}
          </div>
          {/* <div>
              
                <Tooltip id={"dfc-expanded"}
                  text={"Collapse sidebar"}
                  place={"right"}>
                  <span className="fa fa-angle-double-left " style={{ cursor: "pointer" }}
                    >
                  </span>
                </Tooltip>
              
            </div> */}
        </div>
        <div style={{
          height: "calc(100vh - 170px)", padding: 15, paddingTop: 0, display: "block",
          overflowY: "hidden"
        }}>
          <Box>
            {_.map(finalData, (val, index) => {
              return (<div key={index} className={val.name == groupId ? "foldersDetailsboxSelected" : "foldersDetailsbox"} style={{ cursor: 'pointer', marginBottom: '5px' }}
                onClick={() => { setGroupId(val.name) }}
              ><div style={{ padding: '7px' }}>{val.modifiedBy}</div>
              </div>)
            })
            }
          </Box>

        </div>
      </div>
    </>
  )
};

export default FilterSideBar;
